import React, { useEffect, useState } from "react";

// Modal Component (unchanged)
const Modal = ({ show, onClose, job, handleApply }) => {
  if (!show || !job) return null;

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <button style={styles.modalCloseBtn} onClick={onClose}>
          ×
        </button>
        <h2>{job.position}</h2>
        <p><strong>Vacancy No:</strong> {job.vacancy_no}</p>
        <p><strong>Location:</strong> {job.location}</p>
        <p><strong>Deadline:</strong> {job.deadline}</p>
        <p><strong>Status:</strong> {job.status}</p>

        <h3>Job Purpose</h3>
<div
  dangerouslySetInnerHTML={{
    __html: job.job_purpose || "",
  }}
/>

<h3>Responsibilities</h3>
<div
  dangerouslySetInnerHTML={{
    __html: job.responsibilities || "",
  }}
/>

<h3>Qualifications</h3>
<div
  dangerouslySetInnerHTML={{
    __html: job.qualifications || "",
  }}
/>

        {/* <h3>Job Purpose</h3>
        <p>{job.job_purpose}</p>
        <h3>Responsibilities</h3>
        <p>{job.responsibilities}</p>
        <h3>Qualifications</h3>
        <p>{job.qualifications}</p> */}
        <button style={styles.applyBtn} onClick={handleApply}>
          Apply Now
        </button>
      </div>
    </div>
  );
};

const CareersMBS = () => {
  const [vacancies, setVacancies] = useState([]);
  const [activeTab, setActiveTab] = useState("external"); // internal tabs
  const [activeLink, setActiveLink] = useState("Job Opportunities"); // sidebar link highlight
  const [selectedJob, setSelectedJob] = useState(null);

  useEffect(() => {
    fetch("https://careers-admin.mbsmw.org/api/vacancies")
    // fetch("http://192.168.0.5:8009/api/vacancies")
      .then((res) => res.json())
      .then((data) => setVacancies(data))
      .catch((err) => console.error("Error loading vacancies:", err));
  }, []);

  const handleApply = () => {
    window.location.href = "https://careers.mbsmw.org/";
  };

  const filteredVacancies = vacancies.filter(
    (v) => v.form_type === activeTab
  );

  const getLinkStyle = (linkName) => ({
    ...styles.navItem,
    backgroundColor: activeLink === linkName ? "#FF6C2F" : "transparent",
    color: activeLink === linkName ? "#fff" : "#222",
    borderRadius: "8px",
    padding: "8px 20px",
    margin: "5px 0",
    fontWeight: activeLink === linkName ? 600 : 500,
    cursor: "pointer",
  });

  return (
    <div style={styles.page}> 
      {/* Sidebar */}
      <aside style={styles.sidebar}>
        {/* <img
          src="/logo.png" 
          alt="MBS Logo" 
          style={styles.logo}
        /> */}
        <div style={styles.menuHeader}>Menu</div>
        <nav style={styles.nav}>
          <div
            style={getLinkStyle("Job Opportunities")}
            onClick={() => {
              setActiveTab("external");
              setActiveLink("Job Opportunities");
            }}
          >
            Job Opportunities
          </div>
          <div
            style={getLinkStyle("Internship Opportunities")}
            onClick={() => {
              setActiveTab("internship");
              setActiveLink("Internship Opportunities");
            }}
          >
            Internship Opportunities
          </div>
          <a
            href="https://careers.mbsmw.org/"
            style={getLinkStyle("Sign Up / Login")}
            onClick={() => setActiveLink("Sign Up / Login")}
          >
            Sign Up / Login
          </a>

          {/* <a
            href="http://192.168.0.5:7001/"
            style={getLinkStyle("Sign Up / Login")}
            onClick={() => setActiveLink("Sign Up / Login")}
          >
            Sign Up / Login
          </a> */}


          <div
            style={getLinkStyle("Help")}
            onClick={() => setActiveLink("Help")}
          >
            Help
          </div>
        </nav>
      </aside>

      {/* Main Content */}
      <main style={styles.main}>
        <div style={styles.header}>
          <h1 style={styles.headerTitle}>WELCOME TO CAREERS@MBS</h1>
        </div>

        <div style={styles.infoBox}>
          <p>
            <strong>Careers@MBS</strong> is Malawi Bureau of Standards's web-based
            career management system providing job vacancy details to the public.
            You can search and apply for jobs.
          </p>
          <p><strong>How does it work?</strong></p>
          <ul>
            <li>View the job openings listed below</li>
            <li>Click the Position name to view full job details</li>
            <li>
              For first timers, you will be taken to a sign up screen;
              otherwise, log in
            </li>
            <li>A step-by-step wizard will guide you through the application process</li>
          </ul>
        </div>

        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead style={styles.tableHeaderRow}>
              <tr>
                <th style={styles.th}>Vacancy No</th>
                <th style={styles.th}>Position</th>
                <th style={styles.th}>Deadline</th>
                <th style={styles.th}>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredVacancies.length > 0 ? (
                filteredVacancies.map((job) => (
                  <tr key={job.id}>
                    <td style={styles.td}>{job.vacancy_no}</td>
                    <td
                      style={{ ...styles.td, fontWeight: 600, color: "#FF6C2F", cursor: "pointer" }}
                      onClick={() => setSelectedJob(job)}
                    >
                      {job.position}
                    </td>
                    <td style={styles.td}>{job.deadline}</td>
                    <td style={styles.td}>{job.status}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={styles.noVacancies}>
                    No vacancies available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Modal
          show={!!selectedJob}
          onClose={() => setSelectedJob(null)}
          job={selectedJob}
          handleApply={handleApply}
        />

        {/* <footer style={styles.footer}>
          © {new Date().getFullYear()} Malawi Bureau of Standards
        </footer> */}
      </main>
    </div>
  );
};

const styles = {
  page: { display: "flex", fontFamily: "'Poppins', sans-serif", backgroundColor: "#f7f7f7", minHeight: "100vh" },
  sidebar: { width: "260px", backgroundColor: "#fff", borderRight: "2px solid #f0f0f0", padding: "20px 0", display: "flex", flexDirection: "column", alignItems: "center" },
  logo: { width: "180px", marginBottom: "20px" },
  menuHeader: { width: "100%", backgroundColor: "#FF6C2F", color: "#fff", textAlign: "center", fontWeight: "bold", padding: "10px 0" },
  nav: { marginTop: "10px", width: "100%", display: "flex", flexDirection: "column", alignItems: "flex-start", paddingLeft: "30px" },
  navItem: { color: "#222", textDecoration: "none", margin: "8px 0", fontSize: "0.95rem", cursor: "pointer" },
  main: { flex: 1, padding: "20px 30px" },
  header: { backgroundColor: "#FF6C2F", padding: "20px 30px", borderRadius: "10px", color: "#fff", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "20px" },
  headerTitle: { margin: 0, textTransform: "uppercase", fontSize: "1.4rem", fontWeight: "700" },
  infoBox: { background: "#fff", width: "95%", margin: "0 auto 25px", padding: "25px 30px", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)", lineHeight: "1.6" },
  tableContainer: { background: "#fff", width: "95%", margin: "0 auto", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)", overflow: "hidden" },
  table: { width: "100%", borderCollapse: "collapse" },
  tableHeaderRow: { backgroundColor: "#FFB693" },
  th: { padding: "14px 16px", textAlign: "left", fontWeight: "bold", fontSize: "1rem", borderBottom: "2px solid #FF6C2F" },
  td: { padding: "12px 16px", borderBottom: "1px solid #eee", fontSize: "0.95rem" },
  noVacancies: { textAlign: "center", padding: "20px", color: "#777" },
  applyBtn: { backgroundColor: "#FF6C2F", color: "#fff", border: "none", borderRadius: "25px", padding: "12px 30px", fontWeight: "bold", marginTop: "20px", cursor: "pointer" },
  footer: { textAlign: "center", marginTop: "40px", color: "#555", fontSize: "0.9rem" },
  modalOverlay: { position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
  modalContent: { background: "#fff", padding: "30px", borderRadius: "10px", width: "80%", maxHeight: "90vh", overflowY: "auto", position: "relative" },
  modalCloseBtn: { position: "absolute", top: "15px", right: "15px", background: "transparent", border: "none", fontSize: "1.5rem", cursor: "pointer" },
};

export default CareersMBS;
